import { c as _c } from "react/compiler-runtime";
import { useMutation } from '@tanstack/react-query';
import { TRACKING_PARAMS, type TrackingProps } from '@/hooks/use-tracking-storage';

// The website's own "Talk to an expert" form, so these leads land where onefootprint.com's do. The
// field names are that form's HubSpot definition; the submit endpoint takes no credentials.
const HUBSPOT_PORTAL_ID = '44814407';
const HUBSPOT_FORM_ID = '15f21d51-8890-4792-9477-65f49ca49b77'; // nosemgrep
const HUBSPOT_SUBMIT_URL = 'https://api.hsforms.com/submissions/v3/integration/submit';
type DemoRequest = {
  firstName: string;
  lastName: string;
  companyName: string;
  email: string;
  jobTitle: string;
  phoneNumber: string;
  message: string;
};
const requestDemo = async ({
  tracking,
  ...request
}: DemoRequest & {
  tracking: TrackingProps;
}) => {
  const fields = [{
    name: 'firstname',
    value: request.firstName
  }, {
    name: 'lastname',
    value: request.lastName
  }, {
    name: 'company',
    value: request.companyName
  }, {
    name: 'email',
    value: request.email
  }, {
    name: 'jobtitle',
    value: request.jobTitle
  }, {
    name: 'mobilephone',
    value: request.phoneNumber
  }, {
    name: 'message',
    value: request.message
  }, ...Object.entries(TRACKING_PARAMS).map(([name, field]) => ({
    name,
    value: tracking[field]
  }))].filter(field => Boolean(field.value));
  const response = await fetch(`${HUBSPOT_SUBMIT_URL}/${HUBSPOT_PORTAL_ID}/${HUBSPOT_FORM_ID}`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify({
      fields,
      context: {
        pageUri: window.location.href,
        pageName: document.title
      }
    })
  });
  if (!response.ok) {
    throw new Error(`HubSpot rejected the demo request (${response.status})`);
  }
};
const useRequestDemo = () => {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {
      mutationFn: requestDemo
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return useMutation(t0);
};
export type { DemoRequest };
export default useRequestDemo;